import { useCallback, useMemo } from 'react';
import type { RevieveProduct } from 'revieve';

import type { NovageSkincareConfiguration } from '../models';
import { getRevieveUserId } from '../utils';

export interface UseSessionStorageProps {
  novageSkincareConfiguration: NovageSkincareConfiguration;
}

const getProductKey = () => `persist:${getRevieveUserId()}:product`;

export const useSessionStorage = ({
  novageSkincareConfiguration: { env, partnerId },
}: UseSessionStorageProps) => {
  const advisorKey = `persist:${partnerId}-${env}`;
  const clear = useCallback(() => {
    window.sessionStorage.removeItem(advisorKey);
    window.sessionStorage.removeItem(getProductKey());
  }, [advisorKey]);
  const restoreProduct = useCallback(() => {
    const product = window.sessionStorage.getItem(getProductKey());

    return product ? (JSON.parse(product) as RevieveProduct) : undefined;
  }, []);
  const storeProduct = useCallback(
    (product: RevieveProduct) =>
      window.sessionStorage.setItem(getProductKey(), JSON.stringify(product)),
    [],
  );

  return useMemo(
    () => ({ clear, restoreProduct, storeProduct }),
    [clear, restoreProduct, storeProduct],
  );
};
